module.exports = __webpack_public_path__ + "img/info_sp_12.5c201450.png";